import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';
import HeroSection from './components/HeroSection';
import UseCasesSection from './components/UseCasesSection';
import VariantsSection from './components/VariantsSection';
import GallerySection from './components/GallerySection';
import WhySection from './components/WhySection';
import CitiesSection from '@/components/feature/CitiesSection';
import OrderSection from './components/OrderSection';

export default function BenchesPage() {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0">
        <HeroSection />
        <UseCasesSection />
        <VariantsSection />
        <GallerySection />
        <WhySection />
        <CitiesSection productName="Скамейки" productPath="/products/benches" />
        <OrderSection />
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}